'use strict';


    var zrUtil = require('zrender/lib/core/util');

    require('../coord/polar/polarCreator');
    require('./angleAxis');
    require('./radiusAxis');
    require('./axisPointer');

    require('./axisPointer/PolarAxisPointer');

    // For reducing size of echarts.min, barLayoutPolar is required by polar.
    require('../echarts').registerLayout(zrUtil.curry(require('../layout/barPolar'), 'bar'));

    // Polar view
    require('../echarts').extendComponentView({
        type: 'polar'
    });



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/polar.js
// module id = 903
// module chunks = 0